export type DeviceTier =
  | 'cast_dongle_high_risk'
  | 'cast_dongle_medium_risk'
  | 'cast_tv_high_risk'
  | 'cast_tv_low_risk'
  | 'android_tv'
  | 'smart_display'
  | 'audio_only'
  | 'unknown';

interface CastDeviceCapabilities {
  IS_VIDEO_SUPPORTED?: boolean;
  IS_AUDIO_SUPPORTED?: boolean;
  IS_TOUCH_SUPPORTED?: boolean;
}

export function getDeviceTier(): DeviceTier {
  const capabilityList = getDeviceCapabilities();
  const context = (window as any).cast?.framework?.CastReceiverContext?.getInstance?.();

  const caps: CastDeviceCapabilities = context?.getDeviceCapabilities?.() ?? {};

  const ua = navigator.userAgent ?? '';

  const isAndroidTV = ua.includes('DeviceType/AndroidTV');
  const isGoogleTV = ua.includes('Google TV');

  const isChromecast = ua.includes('CrKey') || ua.includes('Chromecast');

  const isFuchsia = ua.includes('Fuchsia');

  const isArmV7 = ua.includes('armv7l');

  const hasRemoteInput =
    capabilityList.includes('remote_control_input_supported') || capabilityList.includes('dpad_input_supported');

  const hasAdvancedVideo =
    capabilityList.includes('is_dv_supported') ||
    capabilityList.includes('is_dolby_atmos_supported') ||
    capabilityList.includes('is_cbcs_supported');

  // Audio-only devices
  if (caps.IS_VIDEO_SUPPORTED === false) {
    return 'audio_only';
  }

  // Nest Hub / Smart Displays
  if (caps.IS_TOUCH_SUPPORTED || isFuchsia) {
    return 'smart_display';
  }

  // Google TV / Android TV
  if (isAndroidTV || isGoogleTV) {
    return 'android_tv';
  }

  if (isChromecast) {
    // Chromecast built-in TVs / embedded Cast platforms
    if (hasRemoteInput) {
      return hasAdvancedVideo ? 'cast_tv_low_risk' : 'cast_tv_high_risk';
    }

    // Older Chromecast dongles
    if (isArmV7 && !hasAdvancedVideo) {
      return 'cast_dongle_high_risk';
    }

    // Chromecast Ultra / newer dongles
    return 'cast_dongle_medium_risk';
  }

  return 'unknown';
}
export function getDeviceCapabilities(): string[] {
  const context = (window as any).cast?.framework?.CastReceiverContext?.getInstance?.();
  const caps: CastDeviceCapabilities = context?.getDeviceCapabilities?.() ?? {};

  return (Object.keys(caps) as (keyof CastDeviceCapabilities)[]).filter((key) => caps[key] === true);
}
